import React from 'react';
import { PageTitle } from '../../../../_metronic/layout/core';
import { Link, useParams } from 'react-router-dom';
import { Col, Row } from 'react-bootstrap';
import { KTSVG, toAbsoluteUrl } from '../../../../_metronic/helpers';

const CatalogoEtiquetas: React.FC = () => {
    const { id } = useParams();
    return (
        <>
            <PageTitle>Catálogo de Etiquetas</PageTitle>
            <Row>
                <Col md={3} className='py-5'>
                    <Link to={"/CatalogoEtiquetas/AnalisisContexto"} className="btn btn-flex btn-primary w-100">
                        <KTSVG
                            path="/media/icons/duotune/text/txt009.svg"
                            className="svg-icon svg-icon-3x"
                        />
                        <span className="d-flex flex-column align-items-start ms-2">
                            <span className="fs-3 fw-bolder">Análisis de contexto</span>
                        </span>
                    </Link>
                </Col>
                <Col md={3} className='py-5 center'>
                    <a href="#" className="btn btn-flex btn-primary w-100">
                        <KTSVG
                            path="/media/icons/duotune/text/txt009.svg"
                            className="svg-icon svg-icon-3x"
                        />
                        <span className="d-flex flex-column align-items-start ms-2">
                            <span className="fs-3 fw-bolder">Estrategias</span>
                        </span>
                    </a>
                </Col>
                <Col md={3} className='py-5'>
                    <a href="#" className="btn btn-flex btn-primary w-100">
                        <KTSVG
                            path="/media/icons/duotune/text/txt009.svg"
                            className="svg-icon svg-icon-3x"
                        />
                        <span className="d-flex flex-column align-items-start ms-2">
                            <span className="fs-3 fw-bolder">Consecuencias</span>
                        </span>
                    </a>
                </Col>
                <Col md={3} className='py-5'>
                    <a href="#" className="btn btn-flex btn-primary w-100">
                        <KTSVG
                            path="/media/icons/duotune/text/txt009.svg"
                            className="svg-icon svg-icon-3x"
                        />
                        <span className="d-flex flex-column align-items-start ms-2">
                            <span className="fs-3 fw-bolder">Causas</span>
                        </span>
                    </a>
                </Col>
                <Col md={3} className='py-5'>
                    <a href="#" className="btn btn-flex btn-primary w-100">
                        <KTSVG
                            path="/media/icons/duotune/text/txt009.svg"
                            className="svg-icon svg-icon-3x"
                        />
                        <span className="d-flex flex-column align-items-start ms-2">
                            <span className="fs-3 fw-bolder">Responsables</span>
                        </span>
                    </a>
                </Col>
                <Col md={3} className='py-5'>
                    <a href="#" className="btn btn-flex btn-primary w-100">
                        <KTSVG
                            path="/media/icons/duotune/text/txt009.svg"
                            className="svg-icon svg-icon-3x"
                        />
                        <span className="d-flex flex-column align-items-start ms-2">
                            <span className="fs-3 fw-bolder">Corrupción e impunidad</span>
                        </span>
                    </a>
                </Col>
                <Col md={3} className='py-5'>
                    <a href="#" className="btn btn-flex btn-primary w-100">
                        <KTSVG
                            path="/media/icons/duotune/text/txt009.svg"
                            className="svg-icon svg-icon-3x"
                        />
                        <span className="d-flex flex-column align-items-start ms-2">
                            <span className="fs-3 fw-bolder">Factores de persistencia</span>
                        </span>
                    </a>
                </Col>
            </Row>
        </>
    )
}


export { CatalogoEtiquetas };